module.exports = __webpack_public_path__ + "static/media/pin3.539af353.png";